import { HomePage, TasksPage, ProfilePage, MembersPage, ClaimsPage, ReportsPage, NewMemberPage, NewClaimPage, TestformPage, DependantFormPage, BeneficiaryFormPage, ReportViewPage, UploadMembersPage, MemberDependantPage, MembersGridPage, EnquiriesPage, SchemeDetailsPage, BulkGridPage, PayPage, CustomTitlePage, ChangesRequestsPage, ViewCommissionsPage, CommissionsPage, QuotationsPage, NewQuotationsPage, NewQuotationPage, AddQuoteRiderPage, FAQPage, ReceiptsPage, TermsOfServicePage, SupplimentaryPage, LoanTopUpPage, PayOffPage, NewTravelerPage, InTrayPage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
  {
    path: '/tasks',
    element: TasksPage
  },
  {
    path: '/profile',
    element: ProfilePage
  },
  {
    path: '/home',
    element: HomePage
  },
  {
    path: '/members',
    element: MembersPage
  },
  {
    path: '/claims',
    element: ClaimsPage
  },
  {
    path: '/reports',
    element: ReportsPage
  },
  {
    path: '/new-member',
    element: NewMemberPage
  },
  {
    path: '/new-claim',
    element: NewClaimPage
  },
  {
    path: '/testform',
    element: TestformPage
  },
  {
    path: '/dependant-form',
    element: DependantFormPage
  },
  {
    path: '/beneficiary-form',
    element: BeneficiaryFormPage
  }, 
  {
    path: '/report-view',
    element: ReportViewPage
  }, 
  {
    path: '/upload-members',
    element: UploadMembersPage
  }, 
  {
    path: '/member-dependant',
    element: MemberDependantPage
  }, 
  {
    path: '/members-grid',
    element: MembersGridPage
  }, 
  {
    path: '/enquiries',
    element: EnquiriesPage
  }, 
  {
    path: '/scheme-details',
    element: SchemeDetailsPage
  }, 
  {
    path: '/bulk-grid',
    element: BulkGridPage
  }, 
  {
    path: '/pay',
    element: PayPage
  }, 
  {
    path: '/custom-title',
    element: CustomTitlePage
  }, 
  {
    path: '/changes-requests',
    element: ChangesRequestsPage
  }, 
  {
    path: '/view-commissions',
    element: ViewCommissionsPage
  }, 
  {
    path: '/commissions',
    element: CommissionsPage
  }, 
  {
    path: '/quotations',
    element: QuotationsPage
  }, 
  {
    path: '/new-quotations',
    element: NewQuotationsPage
  }, 
  {
    path: '/new-quotation',
    element: NewQuotationPage
  }, 
  {
    path: '/add-quote-rider',
    element: AddQuoteRiderPage
  }, 
  {
    path: '/faq',
    element: FAQPage
  }, 
  {
    path: '/receipts',
    element: ReceiptsPage
  }, 
  {
    path: '/terms-of-service',
    element: TermsOfServicePage
  }, 
  {
    path: '/supplimentary',
    element: SupplimentaryPage
  }, 
  {
    path: '/loan-top-up',
    element: LoanTopUpPage
  }, 
  {
    path: '/pay-off',
    element: PayOffPage
  }, 
  {
    path: '/new-traveler',
    element: NewTravelerPage
  }, 
  {
    path: '/in-tray',
    element: InTrayPage
  }
];

export default routes.map(route => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path)
  };
});

